import {computed, Ref} from "@vue/composition-api";
import Vue from "vue";
import {UserEntityInterface} from "@tool/tool.types";

type BaseInertiaProps<T = {}> = T & {
    user: UserEntityInterface;
    errors: Record<string, string | undefined>;
    billing_trial_ends_at: null | string;
}

export default function useInertiaData<T>(): Ref<BaseInertiaProps<T>> {
    return computed(() => Vue.prototype.$page.props);
}
